import React, { useState, useEffect } from 'react';
import AdminNavbar from '../components/adminNavbar';
import { Link } from 'react-router-dom';
import deleteicon from '../../images/delete.png';
//import expenseData from '../../components/expense.json'; // Import the JSON data
import axios from 'axios';


const BASE_API_URL = process.env.REACT_APP_API_URL;
const API_URL = `${BASE_API_URL}/Users`;

export default function AdminUsers({ setToken }) {
    const token = localStorage.getItem('token');
    const [usersData, setData] = useState([]);
    const [onDeleteError, setOnDeleteError] = useState(false);

     const itemsPerPage = 10;
     const [currentPage, setCurrentPage] = useState(1);
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        },
    };

    const getUsersData = () => {
        // Perform AJAX call using Axios here
        axios.get(`${API_URL}`, config)
            .then(response => {
                console.log(response);
                const fetchedData = response.data;
                setData(fetchedData); // Store the fetched data in state
            })
            .catch(error => {
                // Handle errors
            });
    }
    useEffect(() => {
        getUsersData();
    }, []); // The empty array means this effect will run only once (on mount)

     // Calculate the total number of pages based on data length and items per page
    const totalPages = Math.ceil(usersData.length / itemsPerPage);

     // Function to slice the data based on the current page
     const getPaginatedData = () => {
          const startIndex = (currentPage - 1) * itemsPerPage;
          const endIndex = startIndex + itemsPerPage;
         return usersData.slice(startIndex, endIndex);
     };

     const handlePageChange = (page) => {
          setCurrentPage(page);
     };

    const handleDelete = (userId) => {
        setOnDeleteError(false);
        axios.delete(`${API_URL}/${userId}`, null, config)
            .then(response => {
                console.log(response);
                if (response != null && response !== undefined && response.status === 200) {
                    getUsersData();
                }
            })
            .catch(error => {
                setOnDeleteError(true);
            });

    }
     return (
          <>
               <AdminNavbar setToken={setToken} />
               <div className="events">
                    <div className="res-container sm-pt-10">
                         <div className="card p-0">
                              <div className="row">
                                   <div className="col-md-12 p-0">
                                        <div className="card common-card">
                                             <div className="card-header d-flex jc-sb">
                                                  <div className="row d-flex w-100">
                                                       <div className="col-4">
                                                 <h3 className="head m-0">Users</h3>
                                                       </div>
                                                       <div className="col-8 d-flex jc-e">
                                                            <div>
                                                     <Link to="/admin/usersadd" className="btn btn-primary">
                                                                      Add Users
                                                                 </Link>
                                                            </div>
                                                       </div>
                                                  </div>
                                             </div>
                                             <div className="card-body">
                                                  <table className="table">
                                                       <thead>
                                                            <tr>
                                                                 <th>Name</th>
                                                                 <th>Email</th>
                                                                 <th>Gender</th>
                                                                 <th>Phone Number</th>
                                                                 <th>Address</th>
                                                                 <th>City</th>
                                                                 <th>State</th>
                                                                 <th>Country</th>
                                                                 <th>Postal Code</th>
                                                                 <th>Member Type</th>
                                                     <th>Member Id</th>
                                                     <th className="text-center">Actions</th>
                                                            </tr>
                                                       </thead>
                                                       <tbody>
                                                            {getPaginatedData().map((user, index) => (
                                                                 <tr key={index}>
                                                                    <td>{user.FirstName} {user.LastName}</td>
                                                                    <td>{user.EmailAddress}</td>
                                                                    <td>{user.Gender}</td>
                                                                    <td>{user.PhoneNumber}</td>
                                                                    <td>{user.HomeAddress}</td>
                                                                    <td>{user.City}</td>
                                                                    
                                                                    {/*<td><a href={user.attachments[0]} target="_blank" rel="noopener noreferrer">*/}
                                                                    {/*    View Document*/}
                                                                    {/*</a></td>*/}
                                                                    <td>{user.State}</td>
                                                                    <td>{user.Country}</td>
                                                                    <td>{user.PostalCode}</td>
                                                                    <td>{user.MemberType}</td>
                                                                    <td>{user.MemberId}</td>
                                                                    <td className="text-center"><button style={{ border: '0', background: 'none' }}><img className="action-img del" src={deleteicon} alt="delete" onClick={() => handleDelete(user.UserId)} /></button></td>
                                                                 </tr>
                                                            ))}
                                                       </tbody>
                                                  </table>
                                                  {/* Pagination buttons */}
                                                  <nav aria-label="Page navigation">
                                                       <ul className="pagination">
                                                            {Array.from({ length: totalPages }, (_, index) => (
                                                                 <li
                                                                      key={index}
                                                                      className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                                                                 >
                                                                      <button
                                                                           className="page-link"
                                                                           onClick={() => handlePageChange(index + 1)}
                                                                      >
                                                                           {index + 1}
                                                                      </button>
                                                                 </li>
                                                            ))}
                                                       </ul>
                                                  </nav>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
             </div>
             {/* Popup to show after form submission */}
             {onDeleteError && (
                 <div className="modal d-block">
                     <div className="modal-dialog">
                         <div className="modal-content">
                             <div className="modal-header">
                                 <h5 className="modal-title">Error while deleting user!</h5>
                                 <button
                                     type="button"
                                     className="close"
                                     onClick={() => setOnDeleteError(false)}
                                 >
                                     &times;
                                 </button>
                             </div>
                             <div className="modal-body">
                                 <p>Error while deleting user!</p>
                             </div>
                         </div>
                     </div>
                 </div>
             )}
          </>
     );
}
